import React from 'react'

const VotePage = () => {
  return (
    <div className="flex justify-center items-center min-h-screen">
      <div className="text-3xl">Coming Soon</div>
    </div>)
}

export default VotePage